import React, { useEffect, createElement } from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
function loadWistiaScripts() {
  if (!document.querySelector('script[src="https://fast.wistia.com/player.js"]')) {
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
  }
  if (!document.querySelector('script[src="https://fast.wistia.com/embed/vuyjn0j2l6.js"]')) {
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/vuyjn0j2l6.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
  }
}
export function HeroSection() {
  useEffect(() => {
    loadWistiaScripts();
  }, []);
  return <section className="bg-white py-20 px-4" data-id="element-41">
      <div className="max-w-[900px] mx-auto flex flex-col items-center text-center" data-id="element-42">
        <h1 className="md:text-5xl font-extrabold text-textDark mb-6 text-[24px]" data-id="element-43">
          Tu día está diseñado para mantenerte ocupada, no para hacerte crecer.
        </h1>

        <p className="text-lg md:text-xl text-textDark mb-8 max-w-3xl" data-id="element-44">
          En 90 minutos vas a identificar qué está drenando tiempo, energía y
          foco en tu negocio, y qué debes ajustar para crecer con más control.
        </p>

        <div className="flex flex-col items-start text-left gap-4 mb-10 w-full max-w-2xl mx-auto" data-id="element-45">
          <div className="flex items-start gap-3" data-id="element-46">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-47" />
            <span className="text-lg text-textDark font-medium" data-id="element-48">
              Descubre tus fugas invisibles.
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-49">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-50" />
            <span className="text-lg text-textDark font-medium" data-id="element-51">
              Identifica lo que no suma.
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-52">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-53" />
            <span className="text-lg text-textDark font-medium" data-id="element-54">
              Sal con un criterio claro para priorizar tu 20%.
            </span>
          </div>
        </div>

        <div className="mb-10 rounded-xl overflow-hidden shadow-lg" style={{
        width: '100%',
        maxWidth: '320px',
        margin: '0 auto'
      }} data-id="element-55">
          <style data-id="element-56">{`
            wistia-player[media-id='vuyjn0j2l6']:not(:defined) {
              background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/vuyjn0j2l6/swatch');
              display: block;
              filter: blur(5px);
              padding-top: 177.78%;
            }
          `}</style>
          {/* @ts-ignore */}
          <wistia-player media-id="vuyjn0j2l6" aspect="0.5625" style={{
          width: '100%'
        }} data-id="element-57"></wistia-player>
        </div>

        <CTAButton className="mb-4 w-full md:w-auto" data-id="element-58">
          QUIERO MI ENTRADA A LA SESIÓN
        </CTAButton>

        <p className="text-sm text-textSecondary mt-2" data-id="element-59">
          +21 años en ventas reales. Esto no es motivación. Es criterio.
        </p>
      </div>
    </section>;
}